import { useRef, useState } from "react";
import { IPermissionProps } from "../../models/Login";
import { Toast } from "primereact/toast";
import { Table } from "./Table";

export interface IModal{
    singleData: any,
    open: boolean  
}

export const DataCorrection = (permissions: IPermissionProps) => {
    const [modal,setModal] = useState({singleData: {}, open: false} as IModal);
    const [reload, setReload] = useState(false);
    const toast = useRef<any>(null);

    const hideDialog = () => {
        setModal({ singleData: {}, open: false});
    };

    return (
        <>
            { permissions.is_View && <Table permissions={permissions} toast={toast} reload={reload} setReload={setReload}></Table>}
            <Toast ref={toast} />
        </>
    );
}